import React from "react";
import Header from "shared/components/header";
import "./auth.css";

function Auth(props) {
  return (
    <div className="auth">
      <Header />
      <div className="title-box">
        <h2>We make healthcare payments easy.</h2>
      </div>
      <div className="container">
        <div className="auth-box-container col-md-4 col-sm-6 col-sm-offset-3 col-md-offset-4">
          <div className="auth-box">
            <h3>{props.title}</h3>
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Auth;



// WEBPACK FOOTER //
// ./src/auth/components/auth.js